<template>

  <div class="d-flex flex-column" style="min-width:95vw; max-width:95vw">
    <v-sheet class="ma-1">
      <div class="d-flex flex-row">
        <v-text-field v-model="searchBy" label="Search by Affinity Id | Company Name"
        prepend-inner-icon="mdi-magnify" variant="outlined" />
        <v-btn class="ml-2" @click="getPartnerCompanyBy" icon="mdi-magnify" size="x-large" variant="text" />   
        <div style="width: 50%;"></div>
      </div>
    </v-sheet>
    <v-sheet class="ma-1">
      <v-card 
      variant="outlined"
      title="Partner Company Lookup"
      flat>

      <v-data-table
      style="max-width: 92vw;"
        :items-per-page="-1" 
        :items-per-page-options="[5, 10, 25, 50, -1]"
        :headers="headers"
        :items="partnerCompany"  item-key="id">
          <template v-slot:item.obsfdc="{ item }">
              <v-icon :icon="item.obsfdc > 0 ? 'mdi-check' : 'mdi-close'" />
          </template>
          <template v-slot:item.participation="{ item }">
              <v-icon :icon="item.participation > 0 ? 'mdi-check' : 'mdi-close'" />
          </template>
      </v-data-table>
    </v-card>  
    </v-sheet>
  </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import { usePartnerStore } from '@/stores/partner' 

const partnerStore = usePartnerStore()

const partnerCompany = ref([])
const searchBy = ref('')

const headers = [
{ key: 'affinityID', title: 'Affinity Id'},
{ key: 'companyName', title: 'Company Name'},
{ key: 'country', title: "Country"},
{ key: 'region', title: 'Region'},
{ key: 'manager', title: 'Manager'},
{ key: 'noOfRegisteredUsers', title: 'Registered Users'},
{ key: 'acceptedTsAndCsDate', title: "Accepted T's & C's"},
{ key: 'obsfdc', title: 'OBSFDC'},
{ key: 'participation', title: 'Participation'},
{ key: 'participationReason', title: 'Participation Reason'}
]

onMounted(() => {})

const getPartnerCompanyBy = () => {  
  if (searchBy.value != '') {
    partnerStore.getPartnerCompanyBy(searchBy.value).then(result => {
      if (result.hasData) {
        partnerCompany.value = result.partnerCompany
      }
    })    
  }
} 

</script>

<style scoped>
.modal-mask {
position: fixed;
z-index: 500;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: table;
transition: opacity 0.3s ease;
}

.modal-wrapper {
display: table-cell;
vertical-align: middle;
}

.modal-container {
width: 500px;
margin: 5px auto;
padding: 5px 30px;
background-color: #fff;
border-radius: 10px;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
transition: all 0.3s ease;
}

.modal-body {
margin: 20px 0;
}

.modal-save-button {
margin: 0px 10px;
}

.modal-cancel-button {
margin: 0px 10px;
}

.modal-enter-from {
opacity: 0;
}

.modal-leave-to {
opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}

</style>